import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

class Location extends React.Component {

    constructor(props, context) {
        super(props, context);
        var node = this.props.nodeMap[this.props.location.query["n"]];
        var qnode = node;
        var open = false;
        if (node) {
            while (node.parent) {
                if (node.parent.id == this.props.node.id) {
                    open = true;
                    break;
                }
                node = node.parent;
            }
        }

        this.state = {
            isShowingChildren: open,
            isShowingEdit: false,
            qnode: qnode
        }
    }

    componentDidMount() {
        if (this.state.qnode) {
            if (this.state.qnode.id == this.props.node.id) {
                this.name.scrollIntoView();
            }
        }
    }

    showChildren() {
        this.setState({ isShowingChildren: !this.state.isShowingChildren });
    }

    showEditDropdown() {
        this.setState({ isShowingEdit: !this.state.isShowingEdit });
    }

    closeEditDropdown() {
        this.setState({ isShowingEdit: false });
    }

    renderIcon() {
        var src;
        switch (this.props.node.type) {
            case "meeting_room":
                src = "src/assets/icons/baseline-group-24px.svg";
                return <img src={src} style={{ marginRight: "5px" }} alt="toTopArrowUp"></img>
            case "open_area":
                src = "src/assets/icons/baseline-nature_people-24px.svg";
                return <img src={src} style={{ marginRight: "5px" }} alt="toTopArrowUp"></img>
            case "location":
            case "multicountry":
            case "customer":
                src = (this.state.isShowingChildren) ? "src/assets/icons/baseline-remove_circle_outline-24px.svg" : "src/assets/icons/baseline-add_circle_outline-24px.svg"
                return <img src={src} style={{ marginRight: "5px" }}></img>
            default:
                return null;
        }
    }
    render() {
        let icon = this.renderIcon();
        let canBeParent = (this.props.node.type != "open_area" && this.props.node.type != "meeting_room" && this.props.node.type != "sensor");
        return (
            <li className="location__list__item-wrapper">
                <div className="location__list__item clearfix">
                    <div ref={e => this.name = e} className={"list__item__name pull-left" + ((this.state.qnode && this.props.node.id == this.state.qnode.id) ? " highlight" : "")} onClick={this.showChildren.bind(this)} >
                        {icon}
                        {this.props.node.info.name}
                        {this.props.node.info.useownfp && <div data-tooltip="Use its own floor plan. If this symbol is not showed, parent's floor plan is used instead."><i className="material-icons add--loc--icons material-icons_size" >picture_in_picture</i></div>}
                    </div>
                    <div className="list__item__options pull-right">
                        {
                            canBeParent && <i data-tooltip="Add location" onClick={() => this.props.openAddLocationForm(this.props.node)} className=" material-icons_size material-icons add--loc--icons cursor--pointer pull-left" data-toggle="modal">
                                add_location
                            </i>
                        }
                        <div className="edit__btn pull-left">
                            <i data-tooltip="Edit" className="material-icons_size edit--icons material-icons cursor--pointer" id="dLabel" onClick={this.showEditDropdown.bind(this)}>edit</i>
                            {this.state.isShowingEdit && <div aria-labelledby="dLabel">
                                <div style={{ backgroundColor: 'transparent' }} className={"modals__overlay" + (this.state.isShowingEdit ? "" : " closed")} onClick={this.closeEditDropdown.bind(this)} ></div>
                                <div className={"dropdown-menu settings-location__dropdown " + (this.state.isShowingEdit ? "" : " closed")}>
                                    <ul>
                                        <li onClick={() => {
                                            this.closeEditDropdown();
                                            this.props.openEditLocationForm(this.props.node);
                                        }}><a>Edit Location</a></li>

                                        <li onClick={() => {
                                            this.closeEditDropdown();
                                            this.props.openAddFloorplanForm(this.props.node);
                                        }}> <a>Edit Floor Plan</a></li>

                                        <li><Link to={'live/' + this.props.node.id}>Add Sensor</Link></li>
                                    </ul>
                                </div>
                            </div>
                            }
                        </div>
                        <i data-tooltip="Delete" className="material-icons_size delete--icons material-icons cursor--pointer red-500 pull-left" onClick={() => this.props.openDeleteLocationForm(this.props.node)}>delete_forever</i>
                    </div>
                </div>
                <div className={!this.state.isShowingChildren ? "hidden" : ""}>
                    {this.props.children}
                </div>
            </li>
        );
    }
}

function mapStateToProps(state) {
    return {
        nodeMap: state.overviewReducer.nodeMap
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Location);



// WEBPACK FOOTER //
// ./src/components/pages/locations/settings/location.jsx